import axios from 'axios'

import { configService } from '@/services/ConfigService'

import { apiHeaders } from './headers'
import { handleMockRequest } from './mockAdapter'
import { HttpRequest, HttpResponse } from './types'

/**
 * Sends a request to the backoffice API, or to the in-memory demo API when no base URL is configured. Models call
 * this and nothing else, so switching from demo data to the real backend is an env change.
 */
export async function httpRequest<T, TBody = unknown>(request: HttpRequest<TBody>): Promise<HttpResponse<T>> {
  if (configService.isDemo()) return handleMockRequest<T>(request)

  const { baseUrl } = configService.getConfig().apiConfig
  try {
    // The backend answers `{ success, message, data }` (iws_commerce_server `utils/response.ts`).
    const res = await axios.request<{
      success: boolean
      message: string
      data: T
    }>({
      baseURL: baseUrl,
      method: request.method,
      url: request.url,
      params: request.query,
      data: request.body,
      headers: apiHeaders(),
    })
    if (!res.data.success)
      return {
        success: false,
        error: { status: res.status, message: res.data.message },
      }
    return { success: true, data: res.data.data }
  } catch (e) {
    const status = axios.isAxiosError(e) ? (e.response?.status ?? 0) : 0
    const message = axios.isAxiosError(e) ? (e.response?.data?.message ?? e.message) : 'Request failed'
    console.error(`[pos] ${request.method.toUpperCase()} ${request.url} failed`, status)
    return { success: false, error: { status, message } }
  }
}
